export interface RuntimeScript {
  feature: 'environment' | 'brand' | 'reflection-videos' | 'reflection-channels' | 'carousel-engine' | 'reflection-library' | 'design-system' | 'application' | 'translations' | 'quiz';
  src: string;
}

/** Script order and cache versions mirror the current original runtime contract. */
export const RUNTIME_SCRIPTS: readonly RuntimeScript[] = [
  { feature: 'environment', src: '/env.js?v=70' },
  { feature: 'brand', src: '/charity-logo.js?v=1' },
  { feature: 'reflection-videos', src: '/reflection-videos-data.js?v=5' },
  { feature: 'reflection-channels', src: '/reflection-channels.js?v=1' },
  { feature: 'carousel-engine', src: '/vendor/swiper/swiper-bundle.min.js?v=1' },
  { feature: 'reflection-library', src: '/reflection-library.js?v=7' },
  { feature: 'design-system', src: '/suite.js?v=77' },
  { feature: 'application', src: '/app.js?v=90' },
  { feature: 'translations', src: '/i18n-ext.js?v=77' },
  { feature: 'quiz', src: '/quiz.js?v=8' },
] as const;
